import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getProfileListing } from "../utils/api";
import MatrimonyHeader from "../components/MatrimonyHeader";
import RecentUploadsHero from "../components/RecentUploadsHero";
import MatriHeader from "../components/MatriHeader";

const RecentUploadsPage = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        setLoading(true);
        const data = await getProfileListing();
        setProfiles(data);
      } catch (err) {
        console.error("Error fetching recent uploads:", err);
        setProfiles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  if (loading) {
    return <div className="py-10 text-center">Loading recent uploads...</div>;
  }

  if (profiles.length === 0) {
    return <div className="py-10 text-center">No recent uploads found.</div>;
  }

  return (
    <>
    <MatriHeader />
    <RecentUploadsHero />
    <div className="py-10 px-4 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl md:text-4xl font-bold">
          All Recent{" "}
          <span className="bg-gradient-to-r from-[#E25B46] via-[#B9398E] to-[#E25B46] bg-clip-text text-transparent">
            Uploads
          </span>
        </h2>
        <button
          className="text-sm text-[#E25B46] hover:text-[#B9398E] flex items-center gap-1 group"
          onClick={() => navigate(-1)}
        >
          Back
          <span className="transform group-hover:-translate-x-1 transition-all">←</span>
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {profiles.map((profile, idx) => {
          const age = profile.dob
            ? new Date().getFullYear() - new Date(profile.dob).getFullYear()
            : null;
          const isPrivate = profile.visibility === "Private";

          return (
            <div
              key={idx}
              className="bg-white rounded-3xl overflow-hidden shadow-lg relative"
            >
              <img
                src={profile.images?.[0] || "/m2.png"}
                alt={profile.fullName || "Profile Image"}
                className={`w-full h-[300px] object-cover transition-all ${
                  isPrivate ? "filter blur-md" : ""
                }`}
              />
              {isPrivate && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="bg-black bg-opacity-50 text-white px-4 py-2 rounded-full text-sm">
                    Private Profile
                  </span>
                </div>
              )}
              {profile.tag && (
                <span className="absolute top-2 right-2 bg-white px-3 py-1 mt-2 text-sm rounded-full">
                  {profile.tag}
                </span>
              )}
              <div className="bg-gradient-to-t from-black to-transparent text-white p-4 absolute bottom-0 left-0 right-0">
                <h3 className="text-lg font-bold mb-1">
                  {profile.fullName || "—"}
                </h3>
                <div className="text-xs grid grid-cols-2 gap-2 px-4 py-2">
                  <span className="flex items-center gap-1">
                    <img src="/icon1.png" alt="age" className="w-4 h-4" />{" "}
                    {age ? `${age} Years` : "—"}
                  </span>
                  <span className="flex items-center gap-1">
                    <img src="/icon2.png" alt="height" className="w-4 h-4" />{" "}
                    {profile.height || "—"}
                  </span>
                  <span className="flex items-center gap-1">
                    <img src="/icon3.png" alt="location" className="w-4 h-4" />{" "}
                    {profile.address || "—"}
                  </span>
                  <span className="flex items-center gap-1">
                    <img src="/icon4.png" alt="gender" className="w-4 h-4" />{" "}
                    {profile.gender || "—"}
                  </span>
                </div>
                <button
                  className="mt-3 px-6 py-2 bg-gradient-to-r from-[#E7603C] to-[#B9309A] rounded-full text-sm"
                  onClick={() =>
                    navigate(`/matrimony/profile-details/${profile._id}`)
                  }
                >
                  View Profile
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </>
  );
};

export default RecentUploadsPage;
